import IVehicle from "../types/vehicle-type";
import api from "./auth-interceptor"

class VehicleService {
  getAllVehicles() {
    return api.get(`vehicles/`);
  }

  getInfoById(vehicleId: string) {
    return api.get(`vehicles/${vehicleId}`);
  }

  updateVehicle(vehicleId: string, vehicleContent: IVehicle) {
    return api.put(`vehicles/${vehicleId}`, vehicleContent);
  }

  listVehicle(vehicleContent: IVehicle) {
    return api.post(`vehicles/`, vehicleContent);
  }

  deleteListing(vehicleId: string) {
    return api.delete(`vehicles/${vehicleId}/`);
  }
}

const vehicleService = new VehicleService();
export default vehicleService;